import React, { useState, useEffect } from 'react';

import styles from './Cheque.module.scss';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { Dimmer, Loader, Popup } from 'semantic-ui-react';

import { setDefaultBank } from 'legacy/actions/connectActions';
import { showModal } from 'legacy/actions/modalActions';
import { Bank } from 'legacy/common/types/models';

interface ChequeProps {
  bank: Bank;
  errors: { [key: string]: { message?: string } };
  loading: { [key: string]: boolean };
  handleDelete: () => void;
  setDefaultBank: (bankId: string) => void;
  showModal: (modalType: string, config: any) => void;
}

export const Cheque: React.FC<ChequeProps> = ({
  bank,
  errors,
  loading,
  handleDelete,
  setDefaultBank,
  showModal
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [showError, setShowError] = useState(false);

  const setDefault = () => {
    if (!bank.default) {
      setDefaultBank(bank._id);
    }
  };

  const deleteMe = () => {
    setIsDeleting(true);
    setShowError(false);
    handleDelete();
  };

  useEffect(() => {
    if (isDeleting && errors.DELETE_BANK.message) {
      setIsDeleting(false);
      setShowError(true);
    }
  }, [errors.DELETE_BANK.message]);

  const account = `●●● ${bank.last4}`;

  let inst = '';
  let transit = '';
  let routing = bank.routing;

  if (bank.country === 'CA') {
    const routingParts = bank.routing.split('-');
    transit = routingParts[0];
    inst = routingParts[1];
  }

  return (
    <Popup
      style={{
        opacity: errors.DELETE_BANK.message && showError ? '1' : '0'
      }}
      open={errors.DELETE_BANK.message && showError}
      closeOnDocumentClick
      onClose={() => setShowError(false)}
      position="top center"
      trigger={
        <div key={bank.last4} className={styles.Cheque} data-testid="cheque">
          {isDeleting && (
            <Dimmer active>
              <Loader active />
            </Dimmer>
          )}
          <div className="wrapper">
            <div className="abs-content">
              <div
                className={classnames('payout-type', {
                  default: bank.default,
                  alt: !bank.default
                })}
                onClick={setDefault}
              >
                {bank.default ? 'DEFAULT' : 'MAKE DEFAULT'}
                {loading.SET_DEFAULT_PAYOUT_METHOD && (
                  <Dimmer active>
                    <Loader active size="tiny" />
                  </Dimmer>
                )}
              </div>

              <div className="graphic">
                <img src="/img/illustrations/voidBG.svg" alt="" />
              </div>
              <div className="bn-row info">
                {bank.country === 'CA' ? (
                  <>
                    <div className="col">
                      <div>Transit No.</div>
                      <div>{transit}</div>
                    </div>
                    <div className="col">
                      <div>Inst. No.</div>
                      <div>{inst}</div>
                    </div>
                  </>
                ) : (
                  <div className="col">
                    <div>Routing No.</div>
                    <div>{routing}</div>
                  </div>
                )}

                <div className="col">
                  <div>Account No.</div>
                  <div>{account}</div>
                </div>
              </div>
              <div className="buttons actions">
                <img
                  data-testid="button-delete-cheque"
                  onClick={() =>
                    showModal('CONFIRMATION', {
                      action: deleteMe,
                      actionText: 'Delete Bank',
                      destructive: true,
                      message: 'Are you sure you want to delete this bank?'
                    })
                  }
                  src="/img/buttons/button_Delete.svg"
                  alt="delete"
                  data-cy="delete-cheque-button"
                />
              </div>
            </div>
          </div>
        </div>
      }
    >
      {errors.DELETE_BANK.message}
    </Popup>
  );
};



const mapStateToProps = (state: any) => ({
  loading: state.connect.loading,
  errors: state.connect.errors
});

const actions = { setDefaultBank, showModal };

export default connect(mapStateToProps, actions)(Cheque as any) as any;
